<template>
    <div>
         <v-snackbar bottom  dark color="green darken-2"  v-model="snackbar.show">
        {{ snackbar.message }}
    </v-snackbar>
  <loading :active.sync="isLoading" 
  
        
        :is-full-page="fullPage"></loading>
      <div>
  <b-card title="Sign In" >
    <div style="padding:10px;">
    <b-form-input v-model="customer.username" placeholder="Username"></b-form-input>
    
  </div>
   <div style="padding:10px;">
    <b-form-input type="password" v-model="customer.password" placeholder="Password"></b-form-input>
    
  </div>
  

    <b-card-text class="text-danger" style="font-size:15px;" v-if="alerttxt">Fill all details.. </b-card-text>
 
 <div>
  
  <b-button variant="danger" style="margin-right:1em;" @click="clear">Clear</b-button>
  <b-button style="background-color: #17a2b8;" @click="login">Login</b-button>
  
</div>
<br>
   <span @click="regUser" style="margin-top:1em;">Don't you have any account yet ? <b style="color:red;">Sign Up now</b></span>
  </b-card>
</div>
    </div>
</template>
<script>
import Vue from 'vue'
 import axios from 'axios';
import Router from '../router';
 import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
export default {
     components: {
            Loading
        },
     data: () => ({
          snackbar: {
                show: false,
                message: null,
                color: null
            },
          isLoading: false,
          fullPage: true,
            customer:{
                username:'',
                password:'',
                remarks:'',
                IsActive: true,

                

            },
           
            alerttxt:false,
      }),
      methods:{
         
           regUser(){
               Router.push('/register');
              
              
            },
      
          clear(){
             this.customer.username =''
             this.customer.password = ''
          },
          login(){
                 if(!this.customer.username)
                  {
                    // this.alerttxt = true
                     this.snackbar = {
                       message: "Enter username",
                        color: 'danger',
                        show: true
                    }
                  }
                  else if(!this.customer.password)
                  {
                    this.snackbar = {
                       message: "Enter password",
                        color: 'danger',
                        show: true
                    }
                  }else{
                    // this.alerttxt = false
                     
                 this.isLoading = true;
                 axios.post(this.$bURL+"registeredcustomer/Authenticate",this.customer)
                   .then((response)  =>  {
                    console.log(response.data)
                    this.accountDetails()
                    
                        this.isLoading = false;
                    this.snackbar = {
                        message: "Logged Successfully...",
                        color: 'Success',
                        show: true
                    }

                    
      
                   }, (error)  =>  {
                       console.log(error)
                       this.isLoading = false;
                       this.snackbar = {
                        message: "Sorry username and password does not match",
                        color: 'danger',
                        show: true
                    }
          
                   })

                 }

                     


                  },
                  //+++++++++++++++++++++++++++++++++++++
         accountDetails()
          {
              axios.get(this.$bURL+"registeredcustomer/"+this.customer.username)
              .then((response)  =>  {
               console.log(JSON.stringify(response.data))
               localStorage.setItem("Logeduser",JSON.stringify(response.data))
               localStorage.setItem("islogedIn",true)
               localStorage.setItem("logeduserId",this.customer.username)
               Router.push('/');
             }, (error)  =>  {
                  console.log(error)
                  this.snackbar = {
                        message: "Something went wrong..",
                        color: 'danger',
                        show: true
                    }
             })
                
                 
           
          },





          },
          //------------------------------------------

          
     
     
     }
     

</script>
<style scoped>

</style>